import React from 'react';
import { ContactSupport } from 'components/modules/contact-support';
import { RecsModule } from '../components/recs';
import { UsageSummary } from '../components/usage-summary';
import { WindProject } from '../components/wind-project';
import { UsageGraph as UsageGraphModule } from '../components/usage-graph';
import { UsageAnalysis } from '../components/usage-analysis';
import { Layout } from '../layout';

export const Closed = () => (
  <Layout
    testId="usage-closed"
    additional={<ContactSupport />}
    breakdown={<UsageAnalysis withLink={false} />}
    graph={<UsageGraphModule />}
    project={<WindProject withLink={false} />}
    recs={<RecsModule withLink={false} />}
    summary={<UsageSummary />}
  />
);
